export interface CallMe {
    code: string;
    message: string;
}

export class CallMeHelper {

    static create(): CallMe {
        return {
            code: '',
            message: ''
        };
    }

    static transformFromApi(apiData: Object) {
        const callMe = CallMeHelper.create();
        callMe.code = apiData['CODIGO'];
        callMe.message = apiData['MENSAJE'];
        return callMe;
    }
}